<template>
  <category-index
    :title="title"
    :description="description"
    :items="category.items"
    parent="file-format"
  />
</template>

<script>
/* File Formats overview page
 *
 * @parent:
 * @requests: loadCategory
 * @events:
 * @props:
 * @components: CategoryIndex
 * @methods:
 */

import { mapGetters } from 'vuex';
import CategoryIndex from '~/components/category/CategoryIndex.vue';

export default {
  name: 'FileFormatsIndex',
  components: {
    CategoryIndex,
  },
  async asyncData({ app, store, route, error }) {
    const data = {};

    try {
      const response = await store.dispatch('loadCategory', {
        country: app.i18n.locale,
        category: 'file-format',
        link: route.path,
      });

      data.description = response.items.length + '  categories to browse teaching resources by.';
    } catch (err) {
      // No page matching this route
      error({ statusCode: 404, message: err.message, path: route.path });
    }

    return data;
  },
  data() {
    return {
      title: 'File Formats',
      description: '',
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  computed: {
    ...mapGetters(['category']),
  },
};
</script>
